import { makeStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles';
import { createStyles } from '@material-ui/core/styles';
import { observer } from "mobx-react";
import { useEffect, useState } from 'react';
import { Box, Grid, IconButton, Menu, MenuItem, Select, TextField, Typography } from '@material-ui/core';
import { AutocompleteField, Button, FileUploadArea, MultiSelectField, RadioField, SelectField, createMultiSelectField, createTextField } from '@roc/ui';
import RichTextWithAttachments from '../../utils/richTextWithAttachments';
import { templatePlaceHolders } from 'libs/feature-communication/src/communication/utils/constants';
import { useUserStore } from "@roc/feature-app-core";
import { HtmlContainer } from '../leadDetails/htmlContainer';
import { MAX_FILE_SIZE } from 'libs/feature-communication/src/communication/utils/constants';
import { divider } from '../contactDetails/contactDetailsComponent';
import { BaseLeadStore } from 'libs/client-portal-shared/src/app/modules/companyProfile/stores/baseLeadStore/BaseLeadStore';
import { useStore } from '@roc/client-portal-shared/hooks';
import { businessUnitOptions } from '../leadsDashboard/allLeadDashboard';
import { useCreateListStore } from 'apps/crm-portal/src/app/modules/createList/hooks/useCreateListStore';
import { imageInsertionOptions } from '@roc/feature-utils';
import { Code } from '@material-ui/icons';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    buttonContainer: {
      paddingTop: theme.spacing(1),
      margin: theme.spacing(1, 0, 1),
    },
    attachmentButtonContainer: {
      display: 'flex',
      flexDirection: 'row-reverse',
      height: '30px'
    },
    title: {
      display: 'flex',
      justifyContent: 'flex-start',
    },
    container: {
      display: 'flex',
      justifyContent: 'center',
      width: '100%'
    },
    contentContainer: {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
    },
    previewBox: {
      [theme.breakpoints.up('sm')]: {
        width: '100%'
      },
      [theme.breakpoints.up('lg')]: {
        width: '75%',
      },
    },
    divider: {
      position: 'absolute',
      border: '1px solid grey',
      height: '95%',
      [theme.breakpoints.up('lg')]: {
        left: '53%',
      },
      [theme.breakpoints.down('md')]: {
        left: '50%',
      },
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    modalContainer: {
      position: 'relative'
    }
  })
);

const currentPath = window.location.pathname;

const SELECT_OPTION = "Select"
const CREATE_OPTION = "Create"
const UPDATE_OPTION = "Edit"

export const createTemplateOptions = [
  { label: SELECT_OPTION, value: SELECT_OPTION },
  { label: CREATE_OPTION, value: CREATE_OPTION },
];

export const updateTemplateOptions = [
  { label: SELECT_OPTION, value: SELECT_OPTION },
  { label: UPDATE_OPTION, value: UPDATE_OPTION },
];

export const CadenceEmailTemplates = observer(({ handleClose = () => { }, disableEditTemplateBody, salesforceLeadStore, type, fromGrid = false, stepToEdit }: { handleClose, disableEditTemplateBody: boolean, salesforceLeadStore: BaseLeadStore, type, fromGrid?, stepToEdit }) => {
  const { sendEmailsStore } = salesforceLeadStore;
  const { sendBulkEmailFormStore } = sendEmailsStore;
  const { userStore, userStore: { userInformation } } = useUserStore();
  const { cadenceStore, ringCentralStore } = useStore();
  const userEmail = salesforceLeadStore.isSalesForce ? salesforceLeadStore.emailAddress : userInformation.username;
  const [attachments, setAttachments] = useState<File[]>([]);
  const [mockAttachments, setMockAttachments] = useState([]);
  const [templateAction, setTemplateAction] = useState(SELECT_OPTION);

  useEffect(() => {
    if (stepToEdit) {
      cadenceStore.gridBusinessUnit = stepToEdit?.stepContent?.selectedBusinessUnit
      ringCentralStore.setTemplateBusinessUnit(stepToEdit?.stepContent?.selectedBusinessUnit)
    }
    ringCentralStore.setTemplateBusinessUnit(cadenceStore.gridBusinessUnit)
    sendEmailsStore.getTemplateOptionsForBusinessUnit(cadenceStore.gridBusinessUnit);
    sendEmailsStore.initSentToOptions(type);
  }, []);


  useEffect(() => {
    sendEmailsStore.mockAttachments = mockAttachments;
  }, [mockAttachments]);

  useEffect(() => {
    fetchData()
  }, [sendEmailsStore.templateOptions]);

  useEffect(() => {
    if (templateAction === CREATE_OPTION || templateAction === UPDATE_OPTION) {
      cadenceStore.creatingTemplate = true;
    } else {
      cadenceStore.creatingTemplate = false;
    }
  }, [templateAction]);

  useEffect(() => {
    const lead = salesforceLeadStore.getLeadForEmailPreview();
    sendEmailsStore.updatePreview(userEmail, sendEmailsStore.getContentText, userInformation, lead);
    setMockAttachments(sendEmailsStore.mockAttachments);
  }, [
    sendBulkEmailFormStore.form.fields.contentText.value,
  ]);

  const onFilesChange = (event): void => {
    const { files } = event.target as HTMLInputElement;
    if (files?.length) {
      addFiles(Array.from(files));
    }
  };

  const addFiles = (newFiles: File[]) => {
    const validFiles = newFiles.filter(
      ({ size }) => size < MAX_FILE_SIZE + 1
    );
    setAttachments(currentFiles => [...currentFiles, ...validFiles]);
  }

  const fetchData = async () => {
    if (stepToEdit) {
      const template = sendEmailsStore.templateOptions.find((template) => {
        return template.templateId === stepToEdit?.stepContent?.emailTemplateId
      })
      console.log(template)
      cadenceStore.cadenceForm.onFieldChange('emailTemplateId', template.templateId);
      ringCentralStore.setTemplateId(template?.templateId)
      ringCentralStore.setLabel(template?.label);
      ringCentralStore.setTemplateValue(template?.value);
      ringCentralStore.setTemplateSubject(template?.subject);
      ringCentralStore.setTemplateType(template?.type);
      ringCentralStore.setTemplateAttachments(template?.templateAttachments);
      ringCentralStore.setImageInsertions(template?.imageInsertions);
      ringCentralStore.setBombBombVideoLinkValue(template?.bombBombVideoLink);
      ringCentralStore.setTemplateBusinessUnit(template?.businessUnit)
      sendEmailsStore.setSelectedTemplateOption(template)
    }
  };

  const onEditorChange = (value: string) => {
    sendBulkEmailFormStore.onFieldChange('contentText', value);
  }

  const classes = useStyles();
  return (
    <Grid container spacing={2} className={classes.modalContainer}>
      <Grid item style={{ flex: 1 }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Grid item>
              <Typography variant="h6">Business Unit</Typography>
            </Grid>
            <Grid item container className={classes.contentContainer}>
              <Grid item xs={12}>
                <SelectField
                  value={cadenceStore.gridBusinessUnit}
                  options={businessUnitOptions}
                  onChange={(value) => {
                    sendEmailsStore.reset();
                    cadenceStore.gridBusinessUnit = value;
                    sendEmailsStore.getTemplateOptionsForBusinessUnit(cadenceStore.gridBusinessUnit);
                    ringCentralStore.setTemplateBusinessUnit(value)
                  }}
                  fullWidth
                  variant={'outlined'}
                  testId={'businessUnit'}
                  style={{ height: '35px' }}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid item>
              <Typography variant="h6">Select Action</Typography>
            </Grid>
            <Grid item container className={classes.contentContainer}>
              <Grid item xs={12}>
                <SelectField
                  value={templateAction}
                  options={stepToEdit ? updateTemplateOptions : createTemplateOptions}
                  onChange={(value) => {
                    setTemplateAction(value)
                  }}
                  fullWidth
                  variant={'outlined'}
                  testId={'businessUnit'}
                  style={{ height: '35px' }}
                />
              </Grid>
            </Grid>
          </Grid>
          {templateAction === SELECT_OPTION ?
            <>
              <Grid item xs={12}>
                <Typography variant="h6">Select template</Typography>
                <AutocompleteField
                  label=''
                  placeHolder='Search template'
                  options={sendEmailsStore.templateOptions}
                  value={sendEmailsStore.selectedTemplateOption}
                  onChange={(searchText: any) => {
                    sendEmailsStore.selectedTemplateOption = searchText ?? '';
                  }}
                  onSelect={(option: any) => {
                    sendEmailsStore.setSelectedTemplateOption(option);
                    cadenceStore.cadenceForm.onFieldChange('emailTemplateId', option?.templateId);
                  }} />
              </Grid>
              <Grid item xs={12}>
                <Typography variant="h6">Subject</Typography>
                {createTextField({
                  label: '',
                  fieldName: 'subject',
                  testId: 'subject',
                  store: sendBulkEmailFormStore,
                  disabled: disableEditTemplateBody
                })}
              </Grid>

              <Grid item container className={classes.contentContainer}>
                <Typography variant="h6">Template</Typography>
                <Grid item xs={12}>
                  <RichTextWithAttachments
                    readOnly={disableEditTemplateBody}
                    mockAttachments={mockAttachments}
                    setMockAttachments={setMockAttachments}
                    value={sendBulkEmailFormStore.form.fields.contentText.value}
                    onChange={onEditorChange}
                    attachments={attachments}
                    onFilesChange={onFilesChange}
                    setAttachments={setAttachments}
                    reloadDependencies={[sendEmailsStore.selectedTemplateId]}
                    placeHolders={templatePlaceHolders}
                  />
                </Grid>
              </Grid>
            </>
            : <CreateTemplateForm />}
        </Grid>
      </Grid>
      {!!sendEmailsStore.previewHtml && (
        <>
          <div className={classes.divider}></div>
          <Grid item xs={12} md={6} className={classes.container}>
            <Box className={classes.previewBox}>
              <Box>
                <Box>
                  <Typography variant="h6">From: {userEmail}</Typography>
                </Box>
                <Box>
                  <Typography variant="h6">Subject: {templateAction === SELECT_OPTION ? sendEmailsStore.sendBulkEmailFormStore.form.fields.subject.value : ringCentralStore.templateSubject}</Typography>
                </Box>
              </Box>
              <Box>
                <HtmlContainer html={sendEmailsStore.previewHtml} />
              </Box>
            </Box>
          </Grid>
        </>
      )}
    </Grid>
  )
})

export const CreateTemplateForm = observer(({ handleClose = () => { } }) => {
  const classes = useStyles();
  const { createListStore } = useCreateListStore();
  const { createListFormStore } = createListStore;
  const { ringCentralStore, salesforceLeadStore, userStore, cadenceStore } = useStore();
  const { sendEmailsStore } = salesforceLeadStore;
  const [attachments, setAttachments] = useState<File[]>([]);
  const [mockAttachments, setMockAttachments] = useState<any[]>([]);
  const [placeHolderMenu, setPlaceHolderMenu] = useState(false);
  const [anchorPlaceHolderElement, setAnchorPlaceHolderElement] = useState<null | HTMLElement>(null);
  const [insertions, setInsertions] = useState<any[]>([]);

  const handleMenuOpen = (event) => {
    setAnchorPlaceHolderElement(event.currentTarget);
    setPlaceHolderMenu(true);
  }

  useEffect(() => {
    if (ringCentralStore.templateType === 'email') {
      sendEmailsStore.updatePreview(userStore.userInfo.username, ringCentralStore.getTemplateValue, userStore.userInformation, null, insertions);
    } else {
      ringCentralStore.updatePreview(ringCentralStore.templateValue, userStore.userInformation);
    }
  }, [ringCentralStore.templateType, ringCentralStore.templateValue, ringCentralStore.bombBombVideoLink, insertions]);

  const onFilesChange = (event): void => {
    const { files } = event.target as HTMLInputElement;
    if (files?.length) {
      addFiles(Array.from(files));
    }
  };

  const addFiles = (newFiles: File[]) => {
    const validFiles = newFiles.filter(
      ({ size }) => size < MAX_FILE_SIZE + 1
    );
    setAttachments(currentFiles => [...currentFiles, ...validFiles]);
  }

  useEffect(() => {
    const savedImageUrls = (ringCentralStore.mockTemplateInsertions || '').split(',').filter(Boolean);
    ringCentralStore.setTemplateType("email")
    setMockAttachments(ringCentralStore.templateAttachments);
    sendEmailsStore.imageInsertions = [];
    ringCentralStore.setImageOption();
    setInsertions(savedImageUrls.map((url, i) => ({
      name: `Saved image ${i + 1}`,
      file: { name: `saved-image-${i + 1}` },
      url,
    })));
    currentPath.includes("/backoffice") && createListFormStore.onFieldChange('objectType', 'Lead');
    createListStore.getFilterCriteriaOptions();
  }, []);

  useEffect(() => {
    cadenceStore.templateAtt = attachments;
  }, [attachments]);

  useEffect(() => {
    ringCentralStore.templateAttachments = mockAttachments;
  }, [mockAttachments]);

  useEffect(() => {
    ringCentralStore.templateInsertions = insertions;
    sendEmailsStore.imageInsertions = insertions.filter(item => !!item?.url).map(item => item.url);
  }, [insertions]);

  useEffect(() => {
    if (insertions.length > 1 && ringCentralStore.imageInsertionOption == 'oneImage') {
      setInsertions(prev => prev.slice(0, -1));
    }

    if (ringCentralStore.imageInsertionOption != 'noImage') {
      ringCentralStore.bombBombVideoLink = null;
    }

    if (ringCentralStore.imageInsertionOption == 'noImage') {
      setInsertions([]);
    }

  }, [ringCentralStore.imageInsertionOption]);

  const onRichTextValueChange = (value: string) => {
    ringCentralStore.setTemplateValue(value);
  }

  useEffect(() => {
    createListStore.setFilterCriteriaOptions(createListStore.createListFormStore.form.fields.objectType.value)
  }, [createListStore.createListFormStore.form.fields.objectType.value, createListStore.filterCriteriaOptions]);

  return (
    <>
      <Grid item container className={classes.title}>
        <Grid item>
          <Typography variant="h6">Template Name</Typography>
        </Grid>
        <Grid item container className={classes.contentContainer}>
          <Grid item xs={12}>
            <TextField
              variant="outlined"
              inputProps={{ maxLength: 1000 }}
              value={ringCentralStore.label}
              onChange={value =>
                ringCentralStore.setLabel(value.target.value)
              }
              fullWidth
              minRows={1}
              maxRows={1}
            />
          </Grid>
        </Grid>
        {ringCentralStore.templateType === 'email' && (
          <>
            <Grid item container className={classes.contentContainer}>
              <Grid item xs={12}>
                <SelectField
                  testId='value'
                  variant="outlined"
                  standaloneLabel
                  options={imageInsertionOptions}
                  value={ringCentralStore.imageInsertionOption}
                  onChange={value => { ringCentralStore.imageInsertionOption = value }}
                  fullWidth
                />
              </Grid>
            </Grid>
            {['oneImage', 'twoImagesSideBySide'].includes(ringCentralStore.imageInsertionOption) &&
              <Grid item container className={classes.contentContainer}>
                <Grid item xs={12}>
                  <FileUploadArea items={insertions} setItems={items => setInsertions(items)} fileTypes={['png', 'jpg', 'jpeg', 'webp']}
                    multiple={'twoImagesSideBySide' == ringCentralStore.imageInsertionOption} maxFiles={2} />
                </Grid>
              </Grid>}
            {ringCentralStore.imageInsertionOption == 'noImage' && <> <Grid item>
              <Typography variant="h6">BombBomb Video HTML</Typography>
            </Grid>
              <Grid item container className={classes.contentContainer}>
                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    inputProps={{ maxLength: 1000 }}
                    value={ringCentralStore.bombBombVideoLink}
                    error={ringCentralStore.bombBombVideoLink && !ringCentralStore.bombBombVideoLink?.includes('</a>')}
                    onChange={value =>
                      ringCentralStore.setBombBombVideoLinkValue(value.target.value)
                    }
                    fullWidth
                  />
                </Grid>
              </Grid> </>}
            <Grid item>
              <Typography variant="h6">Template Subject</Typography>
            </Grid>
            <Grid item container className={classes.contentContainer}>
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  inputProps={{ maxLength: 1000 }}
                  value={ringCentralStore.templateSubject}
                  onChange={value =>
                    ringCentralStore.setTemplateSubject(value.target.value)
                  }
                  fullWidth
                />
              </Grid>
            </Grid>
          </>
        )
        }
        <Grid item>
          <Typography variant="h6">Template Value</Typography>
        </Grid>
        <Grid item container className={classes.contentContainer}>
          <Grid container item xs={12}>
            {ringCentralStore.templateType == 'email' ?
              <RichTextWithAttachments
                onFilesChange={onFilesChange}
                attachments={attachments}
                mockAttachments={mockAttachments}
                setMockAttachments={setMockAttachments}
                setAttachments={setAttachments}
                value={ringCentralStore.templateValue}
                onChange={onRichTextValueChange}
                placeHolders={templatePlaceHolders}
              />
              : <Grid xs={12}>
                <Grid className={classes.attachmentButtonContainer}>
                  <IconButton onClick={handleMenuOpen}>{<Code />}</IconButton>
                </Grid>
                <Menu
                  anchorEl={anchorPlaceHolderElement}
                  open={placeHolderMenu}
                  onClose={() => setPlaceHolderMenu(false)}
                >
                  {templatePlaceHolders.map(placeHolder => <MenuItem onClick={() => {
                    setPlaceHolderMenu(false);
                    ringCentralStore.setTemplateValue(`${ringCentralStore.templateValue} ${placeHolder}`);
                  }}>{placeHolder}</MenuItem>)}
                </Menu>
                <TextField
                  variant="outlined"
                  inputProps={{ maxLength: 1000 }}
                  value={ringCentralStore.templateValue}
                  onChange={value =>
                    ringCentralStore.setTemplateValue(value.target.value)
                  }
                  multiline
                  fullWidth
                  minRows={3}
                  maxRows={Infinity}
                />
              </Grid>
            }
          </Grid>
        </Grid>
      </Grid>
    </>
  )
});